<template>
  <span
    class="calico-tier-tracker-badge label--xsmall"
    :class="tierClass"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "CalicoTierTrackerBadge",
  props: {
    label: { type: String, required: true },
    tier: { type: String, default: "na" }
  },
  computed: {
    tierClass() {
      return this.tier ? `${this.tier}` : "tier--na";
    }
  }
};
</script>


<style scoped lang="scss">
.calico-tier-tracker-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0 $space-small;
  height: 26px;
  min-width: 64px;

  font-size: 12px;
  font-weight: 600;
  border-radius: $radius-round;

  background-color: $color-neutral-light;
  color: $color-black;

  &.tier--prime   { background-color: $color-green; }
  &.tier--growth  { background-color: $color-cyan; }
  &.tier--emerging{ background-color: $color-yellow; }
  &.tier--monitor { background-color: $color-orange; }
  &.tier--caution { background-color: $color-pink; }

  &.tier--na {
    background-color: $color-neutral;
    color: $color-black;
  }
}
</style>
